<template>
  <!-- 网点管理 -->
  <div class="page-container">
    <div class="page-top-tool">
      <div class="right-search">
        <span style="margin-left: 20px;">编号：</span>
        <el-input v-model="user_no" clearable placeholder="请输入合伙人编号" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <span style="margin-left: 20px;">姓名：</span>
        <el-input v-model="user_name" clearable placeholder="请输入合伙人姓名" :disabled="loading" size="mini" style="width: 230px;"></el-input>
        <el-button type="primary" icon="el-icon-search" size="mini" :disabled="loading" style="margin-left: 20px;" @click="onSearch">搜索</el-button>
      </div>
      <div>
        <el-radio-group v-model="payment_sate" size="mini" @input="getData">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">待审核</el-radio-button>
          <el-radio-button label="2">待转账</el-radio-button>
          <el-radio-button label="3">已转账</el-radio-button>
          <el-radio-button label="4">被驳回</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-loading="loading"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      style="width: 100%; font-size: 12px; margin: 20px 0px;"
      :header-cell-style="tableHeaderColor"
    >
      <el-table-column prop="agent_no" label="合伙人编号" width="230"></el-table-column>
      <el-table-column prop="agent_name" label="合伙人姓名" width="100"></el-table-column>
      <el-table-column prop="agent_name" label="收款信息" width="150">
        <template slot-scope="scope">
          <div>收款人: {{ scope.row.account_num ? JSON.parse(scope.row.account_num).payee_name : '' }}</div>
          <div>手机号: {{ scope.row.account_num ? JSON.parse(scope.row.account_num).payee_phone : '' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="cash_money" label="提现金额" width="100"></el-table-column>
      <el-table-column prop="apply_time" label="申请时间" width="150"></el-table-column>
      <!-- <el-table-column prop="examine_time" label="审批时间" width="150"></el-table-column> -->
      <el-table-column prop="payment_time" label="打款时间" width="150">
        <template slot-scope="scope">
          {{ getCurrentTime(scope.row.payment_time) }}
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="提现状态" width="100">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.payment_sate == '1'" type="warning" size="mini">待审核</el-tag>
          <el-tag v-else-if="scope.row.payment_sate == '2'" type="warning" size="mini">待转账</el-tag>
          <el-tag v-else-if="scope.row.payment_sate == '3'" type="success" size="mini">已转账</el-tag>
          <el-tag v-else-if="scope.row.payment_sate == '4'" type="danger" size="mini">被驳回</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="备注" width="">
        <template slot-scope="scope">
          <span v-if="scope.row.payment_sate == '3'">{{ scope.row.payment_notes }}</span>
          <span v-if="scope.row.payment_sate == '4'">{{ scope.row.payment_fail_notes }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="userPrower == '1'" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="showDetail(scope.row)">查看详情</el-button>
          <el-button type="text" :disabled="scope.row.payment_sate == '3' || scope.row.payment_sate == '4'" size="mini" @click="onUpdate(scope)">更新状态</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
    :current-page.sync="currentPage"
    :page-size="pageSize"
    hide-on-single-page
    background
    layout="total, prev, pager, next"
    :total="total"
    @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 查看详情 -->
    <el-dialog title="提现详情" :visible.sync="dialogDetailVisible" width="75%" @close="imageDialogClose" :show-close="true" style="margin-top: -50px;">
      <div class="active-detail" style="text-align: center;margin-top: -20px;">
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                提现申请编号
              </div>
            </template>
            <div style="width: 300px">
              {{ activeObj.cash_no }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                合伙人信息
              </div>
            </template>
            <div style="width: 300px;">
              <div style="margin-bottom: 10px;">编号：{{ activeObj.agent_no }}</div>
              <div style="margin-bottom: 10px;">姓名：{{ activeObj.agent_name }}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                收款信息
              </div>
            </template>
            <div style="width: 300px">
              <div style="margin-bottom: 10px;">收款人：{{activeObj.account_num ? JSON.parse(activeObj.account_num).payee_name : ''}}</div>
              <div style="margin-bottom: 10px;">收款人身份证：{{activeObj.account_num ? JSON.parse(activeObj.account_num).payee_cardid : ''}}</div>
              <div style="margin-bottom: 10px;">收款卡号：{{activeObj.account_num ? JSON.parse(activeObj.account_num).payee_acount : ''}}</div>
              <div style="margin-bottom: 10px;">开户行：{{activeObj.account_num ? JSON.parse(activeObj.account_num).payee_bank : ''}}</div>
              <div style="margin-bottom: 10px;">收款人手机号：{{activeObj.account_num ? JSON.parse(activeObj.account_num).payee_phone : ''}}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                打款信息
              </div>
            </template>
            <div style="width: 300px">
              <div style="margin-bottom: 10px;">申请提现金额：{{activeObj.cash_money}}</div>
              <div style="margin-bottom: 10px;">实际打款金额：{{activeObj.payment_amount}}</div>
              <div style="margin-bottom: 10px;">转账手续费：{{activeObj.service_fee}}</div>
              <div style="margin-bottom: 10px;">实际到账金额：{{activeObj.actual_amount}}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                时间信息
              </div>
            </template>
            <div style="width: 300px">
              <div style="margin-bottom: 10px;">申请时间：{{activeObj.apply_time}}</div>
              <div style="margin-bottom: 10px;">审批时间：{{activeObj.examine_time}}</div>
              <div style="margin-bottom: 10px;">打款时间：{{activeObj.payment_time}}</div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                打款状态
              </div>
            </template>
            <div style="width: 300px">
              <el-tag v-if="activeObj.payment_sate == '1'" type="warning" size="mini">待审核</el-tag>
              <el-tag v-else-if="activeObj.payment_sate == '2'" type="warning" size="mini">待转账</el-tag>
              <el-tag v-else-if="activeObj.payment_sate == '3'" type="success" size="mini">已转账</el-tag>
              <el-tag v-else-if="activeObj.payment_sate == '4'" type="danger" size="mini">被驳回</el-tag>
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                打款备注
              </div>
            </template>
            <div style="width: 300px">
              {{ activeObj.payment_notes }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 100px;">
                驳回原因
              </div>
            </template>
            <div style="width: 300px">
              {{ activeObj.payment_fail_notes }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'StorePage',

  data() {
    return {
      userPrower: '', // 用户权限
      user_no: '', // 编号
      user_name: '', // 姓名
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      activeObj: {},
      dialogDetailVisible: false,
      baseurl: '',
      payment_sate: ''
    };
  },

  mounted() {
    this.baseurl = this.$baseUrl
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      this.userPrower = userInfo.prower
    } else {
      this.$http({
        method: 'post',
        url: 'user_exit'
      })
      this.$router.push({
        path: '/login'
      })
    }
    this.getData()
  },

  methods: {
    getData() {
      this.loading = true
      this.$http({
        method: 'post',
        url: `/cash/find?page=${this.currentPage}&pageSize=${this.pageSize}`,
        params: {
          user_no: this.user_no,
          user_name: this.user_name,
          payment_sate:  this.payment_sate
        }
      })
      .then(res => {
        this.loading = false
        if (res.errno == 0) {
          const { data, page, pageSize, count } = res.data
          this.tableData = data
          this.currentPage = page
          this.pageSize = pageSize
          this.total = count
        } else {
          this.$message.error('查询失败')
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('服务端异常，查询失败')
        console.error('查询异常：', err.message);
      })
    },
    tableHeaderColor({row, column, rowIndex, columnIndex}) {
      return 'background-color: #F2F2F2;color:#101010;'
    },
    onSearch() {
      this.currentPage = 1
      this.getData()
    },
    // 页码改变
    handleCurrentChange(page) {
      this.currentPage = page
      this.getData()
    },
    getCurrentTime(data) {
      if (!data || data == '') {
        return ''
      }
      const now = new Date(parseInt(data));
  
      // 获取年、月、日、时、分、秒
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      // 拼接成指定格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 查看名片详情
    showDetail(row) {
      this.activeObj = row
      this.dialogDetailVisible = true
    },
    onUpdate(scope) {
      sessionStorage.setItem('updateCash', JSON.stringify(scope.row))
      this.$router.push({
        path: '/updateCash',
        query: {
          id: scope.row.id
        }
      })
    },
    // 查看图片弹框关闭
    imageDialogClose() {
      this.activeObj = {}
      this.dialogDetailVisible = false
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #fff;
  height: 100%;
  width: 100%;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 25px;
  overflow-y: scroll;

  .page-top-tool {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }
}

/* 修改滚动条样式 */
.page-container::-webkit-scrollbar {
	width: 4px;
}
.page-container::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.active-detail {
  position: relative;
  .shenpi-resuilt-img {
    position: absolute;
    width: 120px;
    top: -70px;
    right: 0px;
    opacity: 0.6;
  }

  .active-images-layout {
    display: flex;
    flex-wrap: wrap;
    .active-images-item {
      margin: 20px;
      cursor: pointer;
    }
  }
}

.active-detail-dialog {
  height: 480px;
  overflow-y: scroll;
}
.active-detail-dialog-bottom {
  margin-top: 20px;
  text-align: right;
}

/* 修改滚动条样式 */
.active-detail-dialog::-webkit-scrollbar {
	width: 4px;
}
.active-detail-dialog::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
	background: rgba(0, 0, 0, 0.2);
}

.copy-link {
  margin-left: 10px;
  color: #409EFF;
}
.copy-link:hover {
  cursor: pointer;
}
.url-style {
  text-decoration: none;
  color: #409EFF;
}
</style>